import React, { useState, useEffect } from 'react';
import { Plus, TrendingUp, DollarSign, PieChart, BarChart3, Edit2, Trash2 } from 'lucide-react';
import axios from 'axios';
import config from '../config/config';
import { useParams, Link } from 'react-router-dom';
const Assets = () => {
  const {expense_id } = useParams();
  const [activeTab, setActiveTab] = useState('assets');
  const [is_recognize, setRecognize]=useState(false);
  const [showAssetModal, setShowAssetModal] = useState(false);
  const [showInvestModal, setShowInvestModal] = useState(false);
  const [showProfitModal, setShowProfitModal] = useState(false);
  const [editingAsset, setEditingAsset] = useState(null);
  const [assetCategories, setAssetCategories] = useState([]);
  const [assets, setAssets] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [investments, setInvestments] = useState([]);
  const [profits, setProfits] = useState([]);
  const [assetMessage, setAssetMessage] = useState(false);
  const [expenseAmount,setExpenseAmount]=useState(0);
   const [expenseDescription,setExpenseDescription]=useState('');
   const [expenseAccountId,setExpenseAccountId]=useState('');
    const [adjustment_type,set_adjustment_type]=useState('');
    const[currentAssetId,setCurrentAssetId]=useState('');

   const [adjustmentReasons,setAdjustmentReasons]=useState([
      'Impairement','Value Increase','Value Decrease','Adjustment'
    ]);
 
  if(expense_id>0){
    setTimeout(function(){
      pullExpenseDetails(expense_id);
   
    },5000);
    
  }

  const [assetForm, setAssetForm] = useState({
    name: '',
    category: '',
    cost: '',
    purchase_date: '',
    depreciation_method: 'straight_line',
    adjustment_type:'',
    lifespan: '',
  });
  const [investForm, setInvestForm] = useState({
    mmf_name: '',
    amount: '',
    account_id: '',
    date: '',
  });
  const [profitForm, setProfitForm] = useState({
    investment_id: '',
    amount: '',
    date: '',
    type: 'Interest',
  });

  const token = localStorage.getItem('token');

  // Format currency values consistently
const formatCurrency = (amount, currency = 'USD') => {
 return new Intl.NumberFormat('en-KE', {
  style: 'currency',
  currency: 'KES',
  minimumFractionDigits: 2
}).format(amount);

};

  // Fetch all data
  const fetchAssetCategories = async () => {
    try {
      const res = await axios.get(`${config.API_URL}/api/fetchAssetCategories`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAssetCategories(res.data.categories || []);
    } catch (err) {
      console.error('Error fetching asset categories:', err);
    }
  };

  const fetchAssets = async () => {
    try {
      const res = await axios.get(`${config.API_URL}/api/fetchAssets`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAssets(res.data.assets || []);
    } catch (err) {
      console.error('Error fetching assets:', err);
    }
  };


  const pullExpenseDetails = async (expense_id) => {
    try {
      const res = await axios.get(`${config.API_URL}/api/getExpenseAmount/${expense_id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setExpenseAmount(res.data.balance || 0);
      if(res.data.balance>0){
           setShowAssetModal(true);
    setRecognize(true);
      }else{
        setAssetMessage(true);
        //alert('You are trying to recognize an expense as a asset. However the amount is 0 meaning it could have been recognized already. ');
      }
      setExpenseDescription(res.data.description || '');
      setExpenseAccountId(res.data.accountId || '')
    } catch (err) {
      console.error('Error fetching assets:', err);
    }
  };

  const fetchAccounts = async () => {
    try {
      const res = await axios.get(`${config.API_URL}/api/fetchAccounts`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAccounts(res.data.accounts || []);
    } catch (err) {
      console.error('Error fetching accounts:', err);
    }
  };

  const fetchInvestments = async () => {
    try {
      const res = await axios.get(`${config.API_URL}/api/fetchInvestments`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setInvestments(res.data.investments || []);
    } catch (err) {
      console.error('Error fetching investments:', err);
    }
  };

  const fetchProfits = async () => {
    try {
      const res = await axios.get(`${config.API_URL}/api/fetchProfits`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setProfits(res.data.profits || []);
    } catch (err) {
      console.error('Error fetching profits:', err);
    }
  };

  useEffect(() => {
    fetchAssetCategories();
    fetchAssets();
    fetchAccounts();
    fetchInvestments();
    fetchProfits();
  }, []);

  // Calculate depreciation (can be moved to backend if preferred)
  const calculateDepreciation = (asset) => {
    const years = (new Date() - new Date(asset.purchase_date)) / (365 * 24 * 60 * 60 * 1000);
    if (asset.depreciation_method === 'straight_line') {
      const annual = asset.cost / asset.lifespan;
      return Math.max(0, asset.cost - annual * years);
    } else if(asset.depreciation_method === 'reducing_balance'){
      const rate = 2 / asset.lifespan;
      return asset.cost * Math.pow(1 - rate, years);
    } else{
       return asset.cost;
    }
  };

  // Handlers for asset management
  const handleAddAsset = async () => {
    if (!assetForm.name || !assetForm.category || !assetForm.cost || !assetForm.purchase_date || !assetForm.lifespan) {
      alert('Please fill all required fields');
      return;
    }

    const payload = {
      ...assetForm,
      cost: Number(assetForm.cost),
      lifespan: Number(assetForm.lifespan),
      expenseAccountId:expenseAccountId,
      adjustment_type:adjustment_type,
      expenseAmount:expenseAmount,
      currentAssetId:currentAssetId,
    };

    try {
       const token = localStorage.getItem('token');
      //console.log('Votehead payload:', payload);
       ////console.log('Fetching CSRF cookie...');
      const csrfResponse = await axios.get(`${config.API_URL}/sanctum/csrf-cookie`, {
        withCredentials: true,
      });
      ////console.log('CSRF Response:', csrfResponse);

      const xsrfToken = getCookie('XSRF-TOKEN');
      ////console.log('XSRF Token:', xsrfToken);
      if (!xsrfToken) {
        throw new Error('CSRF token not found');
      }
      if (editingAsset) {
        await axios.post(`${config.API_URL}/api/updateAsset/${editingAsset.id}`, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-XSRF-TOKEN': xsrfToken,
          },
          withCredentials: true,
        });
      } else {
        await axios.post(`${config.API_URL}/api/storeAsset`, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-XSRF-TOKEN': xsrfToken,
          },
          withCredentials: true,
        });
      }
      fetchAssets();
      setAssetForm({ name: '', category: '', cost: '', purchase_date: '', depreciation_method: 'straight_line', lifespan: '' });
      setShowAssetModal(false);
      setEditingAsset(null);
      localStorage.removeItem('expense_id');
    } catch (err) {
      console.error('Error saving asset:', err);
      alert('Error saving asset');
    }
  };

  const handleEditAsset = (asset) => {
    setEditingAsset(asset);
    setCurrentAssetId(asset.id);
    setAssetForm({
      name: asset.name,
      category: asset.category,
      cost: asset.cost,
      purchase_date: asset.purchase_date,
      depreciation_method: asset.depreciation_method,
      lifespan: asset.lifespan,
    });
    setShowAssetModal(true);
  };

  const handleDeleteAsset = async (id) => {
    try {
      await axios.delete(`${config.API_URL}/api/destroyAsset/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchAssets();
    } catch (err) {
      console.error('Error deleting asset:', err);
      alert('Error deleting asset');
    }
  };

  // Handler for investments
  const handleInvest = async () => {
    if (!investForm.mmf_name || !investForm.amount || !investForm.account_id || !investForm.date) {
      alert('Please fill all required fields');
      return;
    }

    try {
       const token = localStorage.getItem('token');
      //console.log('Votehead payload:', payload);
       ////console.log('Fetching CSRF cookie...');
      const csrfResponse = await axios.get(`${config.API_URL}/sanctum/csrf-cookie`, {
        withCredentials: true,
      });
      ////console.log('CSRF Response:', csrfResponse);

      const xsrfToken = getCookie('XSRF-TOKEN');
      ////console.log('XSRF Token:', xsrfToken);
      if (!xsrfToken) {
        throw new Error('CSRF token not found');
      }
      await axios.post(`${config.API_URL}/api/storeInvestment`, {
        ...investForm,
        amount: Number(investForm.amount),
      }, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-XSRF-TOKEN': xsrfToken,
          },
          withCredentials: true,
        });
      fetchInvestments();
      fetchAccounts();
      setInvestForm({ mmf_name: '', amount: '', account_id: '', date: '' });
      setShowInvestModal(false);
    } catch (err) {
      console.error('Error creating investment:', err);
      alert(err.response?.data?.message || 'Error creating investment');
    }
  };

  // Handler for recording profits
  const handleAddProfit = async () => {
    if (!profitForm.investment_id || !profitForm.amount || !profitForm.date) {
      alert('Please fill all required fields');
      return;
    }

    try {
       const token = localStorage.getItem('token');
      //console.log('Votehead payload:', payload);
       ////console.log('Fetching CSRF cookie...');
      const csrfResponse = await axios.get(`${config.API_URL}/sanctum/csrf-cookie`, {
        withCredentials: true,
      });
      ////console.log('CSRF Response:', csrfResponse);

      const xsrfToken = getCookie('XSRF-TOKEN');
      ////console.log('XSRF Token:', xsrfToken);
      if (!xsrfToken) {
        throw new Error('CSRF token not found');
      }
      await axios.post(`${config.API_URL}/api/storeProfit`, {
        ...profitForm,
        amount: Number(profitForm.amount),
      }, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-XSRF-TOKEN': xsrfToken,
          },
          withCredentials: true,
        });
      fetchProfits();
      fetchAccounts();
      setProfitForm({ investment_id: '', amount: '', date: '', type: 'Interest' });
      setShowProfitModal(false);
    } catch (err) {
      console.error('Error recording profit:', err);
      alert('Error recording profit');
    }
  };

  // Utility function to get cookie
  const getCookie = (name) => {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    if (match) return decodeURIComponent(match[2]);
    return null;
  };


  // Calculated totals
  const totalAssetValue = assets.reduce((sum, a) => sum + calculateDepreciation(a), 0);
  const totalInvested = investments.reduce((sum, i) => sum + Number(i.amount), 0);
  const totalProfits = profits.reduce((sum, p) => sum + Number(p.amount), 0);
  const totalAccounts = accounts.reduce((sum, a) => sum + Number(a.balance), 0);

  return (
    <div className="min-h-screen bg-white p-8 font-sans">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-2">School Asset & Investment Manager</h1>
          <p className="text-gray-500 text-sm">Track school assets and manage MMF investments</p>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8">
          <div className="border border-gray-200 p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-bold text-gray-600">Total Assets Value</span>
              <PieChart className="w-5 h-5 text-gray-400" />
            </div>
            <p className="text-2xl font-bold text-gray-900">{formatCurrency(totalAssetValue)}</p>
          </div>
          <div className="border border-gray-200 p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-bold text-gray-600">Total Invested</span>
              <TrendingUp className="w-5 h-5 text-gray-400" />
            </div>
            <p className="text-2xl font-bold text-gray-900">{formatCurrency(totalInvested)}</p>
          </div>
          <div className="border border-gray-200 p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-bold text-gray-600">Total Profits</span>
              <DollarSign className="w-5 h-5 text-gray-400" />
            </div>
            <p className="text-2xl font-bold text-green-600">{formatCurrency(totalProfits)}</p>
          </div>
          <div className="border border-gray-200 p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-bold text-gray-600">Available Cash</span>
              <BarChart3 className="w-5 h-5 text-gray-400" />
            </div>
            <p className="text-2xl font-bold text-gray-900">KSh {totalAccounts}</p>
          </div>
        </div>

        {/* Tabs */}
        <div className="border-b border-gray-200 mb-6">
          <div className="flex space-x-8">
            <button
              onClick={() => setActiveTab('assets')}
              className={`pb-3 px-1 text-sm font-medium transition-colors ${
                activeTab === 'assets' ? 'border-b-2 border-gray-900 text-gray-900' : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              Assets
            </button>
            <button
              onClick={() => setActiveTab('investments')}
              className={`pb-3 px-1 text-sm font-medium transition-colors ${
                activeTab === 'investments' ? 'border-b-2 border-gray-900 text-gray-900' : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              Investments
            </button>
          <button
              onClick={() => setActiveTab('reports')}
              className={`pb-3 px-1 text-sm font-medium transition-colors ${
                activeTab === 'reports' ? 'border-b-2 border-gray-900 text-gray-900' : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              Reports
            </button>
          </div>
        </div>

        {/* Assets Tab */}
        {activeTab === 'assets' && (
          <div>
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-light text-gray-900">School Assets</h2>
              <button
                onClick={() => {
                  setShowAssetModal(true);
                  setEditingAsset(null);
                  setAssetForm({ name: '', category: '', cost: '', purchase_date: '', depreciation_method: 'straight_line', lifespan: '' });
                }}
                className="flex items-center space-x-2 px-4 py-2 bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition-colors shadow-sm"
              >
                <Plus className="w-4 h-4" />
                <span className="text-sm">Add Asset</span>
              </button>
            </div>

            <div className="border border-gray-200 rounded-xl overflow-hidden shadow-sm">
              <table className="w-full">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Asset Name</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Category</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Original Cost</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Current Value</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Depreciation</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {assets.map((asset) => {
                    const currentVal = calculateDepreciation(asset);
                    return (
                      <tr key={asset.id}>
                        <td className="px-6 py-4 text-sm text-gray-900">{asset.name}</td>
                        <td className="px-6 py-4 text-sm text-gray-500">{asset.categoryName}</td>
                        <td className="px-6 py-4 text-sm text-gray-900">KSh {Number(asset.cost)}</td>
                        <td className="px-6 py-4 text-sm text-gray-900">KSh {currentVal}</td>
                        <td className="px-6 py-4 text-sm text-gray-500">{asset.depreciation_method}</td>
                        <td className="px-6 py-4 text-sm">
                          <div className="flex space-x-2">
                            <button
                              onClick={() => handleEditAsset(asset)}
                              className="p-1 hover:bg-gray-100 rounded"
                              title="Edit Asset"
                            >
                              <Edit2 className="w-4 h-4 text-gray-600" />
                            </button>
                            <button
                              onClick={() => handleDeleteAsset(asset.id)}
                              className="p-1 hover:bg-gray-100 rounded"
                              title="Delete Asset"
                            >
                              <Trash2 className="w-4 h-4 text-red-600" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Investments Tab */}
        {activeTab === 'investments' && (
          <div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              {accounts.map((acc) => (
                <div key={acc.id} className="border border-gray-200 p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow">
                  <h3 className="text-sm font-medium text-gray-600 mb-1">{acc.name}</h3>
                  <p className="text-2xl font-light text-gray-900">KSh {Number(acc.balance)}</p>
                </div>
              ))}
            </div>

            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-light text-gray-900">Active Investments</h2>
              <div className="flex space-x-3">
                <button
                  onClick={() => setShowProfitModal(true)}
                  className="flex items-center space-x-2 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors shadow-sm"
                >
                  <Plus className="w-4 h-4" />
                  <span className="text-sm">Record Profit</span>
                </button>
                <button
                  onClick={() => setShowInvestModal(true)}
                  className="flex items-center space-x-2 px-4 py-2 bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition-colors shadow-sm"
                >
                  <TrendingUp className="w-4 h-4" />
                  <span className="text-sm">New Investment</span>
                </button>
              </div>
            </div>

            <div className="border border-gray-200 rounded-xl overflow-hidden shadow-sm">
              <table className="w-full">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">MMF Name</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Amount</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Source Account</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {investments.map((inv) => (
                    <tr key={inv.id}>
                      <td className="px-6 py-4 text-sm text-gray-900">{inv.mmf_name}</td>
                      <td className="px-6 py-4 text-sm text-gray-900">KSh {Number(inv.amount)}</td>
                      <td className="px-6 py-4 text-sm text-gray-500">{inv.account_name}</td>
                      <td className="px-6 py-4 text-sm text-gray-500">{inv.date}</td>
                      <td className="px-6 py-4">
                        <span className="px-2 py-1 text-xs bg-green-100 text-green-800 rounded-full">{inv.status}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <h3 className="text-lg font-light text-gray-900 mt-8 mb-4">Profit History</h3>
            <div className="border border-gray-200 rounded-xl overflow-hidden shadow-sm">
              <table className="w-full">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Investment</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Amount</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Type</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {profits.map((profit) => (
                    <tr key={profit.id}>
                      <td className="px-6 py-4 text-sm text-gray-900">{profit.mmf_name || 'N/A'}</td>
                      <td className="px-6 py-4 text-sm text-green-600 font-medium">+KSh {Number(profit.amount)}</td>
                      <td className="px-6 py-4 text-sm text-gray-500">{profit.type}</td>
                      <td className="px-6 py-4 text-sm text-gray-500">{profit.date}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Reports Tab */}
        {activeTab === 'reports' && (
          <div className="space-y-6">
            <div className="border border-gray-200 rounded-xl p-6 shadow-sm">
              <h3 className="text-lg font-light text-gray-900 mb-4">Asset Summary Report</h3>
              <div className="space-y-3">
                <div className="flex justify-between py-2 border-b border-gray-100">
                  <span className="text-sm text-gray-600">Total Assets</span>
                  <span className="text-sm font-medium">{assets.length}</span>
                </div>
                <div className="flex justify-between py-2 border-b border-gray-100">
                  <span className="text-sm text-gray-600">Original Asset Value</span>
                  <span className="text-sm font-medium"> {formatCurrency(assets.reduce((s, a) => s + Number(a.cost), 0))}</span>
                </div>
                <div className="flex justify-between py-2 border-b border-gray-100">
                  <span className="text-sm text-gray-600">Current Asset Value</span>
                  <span className="text-sm font-medium">{formatCurrency(totalAssetValue)}</span>
                </div>
                <div className="flex justify-between py-2">
                  <span className="text-sm text-gray-600">Total Depreciation</span>
                  <span className="text-sm font-medium text-red-600">
                    {formatCurrency((assets.reduce((s, a) => s + Number(a.cost), 0) - totalAssetValue))}
                  </span>
                </div>
              </div>
            </div>

            <div className="border border-gray-200 rounded-xl p-6 shadow-sm">
              <h3 className="text-lg font-light text-gray-900 mb-4">Investment Performance Report</h3>
              <div className="space-y-3">
                <div className="flex justify-between py-2 border-b border-gray-100">
                  <span className="text-sm text-gray-600">Active Investments</span>
                  <span className="text-sm font-medium">{investments.filter((i) => i.status === 'active').length}</span>
                </div>
                <div className="flex justify-between py-2 border-b border-gray-100">
                  <span className="text-sm text-gray-600">Total Invested Amount</span>
                  <span className="text-sm font-medium">{formatCurrency(totalInvested)}</span>
                </div>
                <div className="flex justify-between py-2 border-b border-gray-100">
                  <span className="text-sm text-gray-600">Total Returns</span>
                  <span className="text-sm font-medium text-green-600">{formatCurrency(totalProfits)}</span>
                </div>
                <div className="flex justify-between py-2">
                  <span className="text-sm text-gray-600">Return Rate</span>
                  <span className="text-sm font-medium text-green-600">
                    {totalInvested > 0 ? ((totalProfits / totalInvested) * 100) : 0}%
                  </span>
                </div>
              </div>
            </div>

            <div className="border border-gray-200 rounded-xl p-6 shadow-sm">
             {assetMessage && (
                <div className="bg-red-100 text-white p-4">
                  You are trying to recognize an expense as a asset. However the amount is 0 meaning it could have been recognized already.
                </div>
              )}
              <h3 className="text-lg font-light text-gray-900 mb-4">Overall Financial Position</h3>
              <div className="space-y-3">
                <div className="flex justify-between py-2 border-b border-gray-100">
                  <span className="text-sm text-gray-600">Cash in Accounts</span>
                  <span className="text-sm font-medium">{formatCurrency(totalAccounts)}</span>
                </div>
                <div className="flex justify-between py-2 border-b border-gray-100">
                  <span className="text-sm text-gray-600">Invested Capital</span>
                  <span className="text-sm font-medium">{formatCurrency(totalInvested)}</span>
                </div>
                <div className="flex justify-between py-2 border-b border-gray-100">
                  <span className="text-sm text-gray-600">Asset Value</span>
                  <span className="text-sm font-medium">{formatCurrency(totalAssetValue)}</span>
                </div>
                <div className="flex justify-between py-2">
                  <span className="text-sm text-gray-600 font-medium">Total Net Worth</span>
                  <span className="text-sm font-semibold">
                    {formatCurrency((Number(totalAccounts) + Number(totalInvested) + Number(totalAssetValue)))}
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Asset Modal */}
        {showAssetModal && (
          <div className="fixed inset-0 bg-blackk bg-opacity-30 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl p-6 w-full max-w-md shadow-lg">
             {is_recognize && (
                <div className="bg-green-100 text-black p-4">
                  You are recognizing an expense as asset for amount {formatCurrency(expenseAmount)} incurred for {expenseDescription}. Provide the necessary details to proceed.
                </div>
              )}
              <h3 className="text-lg font-light mt-4 text-gray-900 mb-4">{editingAsset ? 'Edit Asset' : 'Add New Asset'}</h3>
              <div className="space-y-4">
              {editingAsset ? 
                <div>
                  <select
                  value={assetForm.adjustment_type}
                  onChange={(e) => set_adjustment_type(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-900"
                  required
                >
                  <option value="">Select Reason</option>
                  {adjustmentReasons.map((cat) => (
                    <option value={cat}>
                      {cat}
                    </option>
                  ))}
                </select>
                </div>
               : ''}
              <label>Asset Name</label>
                <input
                  type="text"
                  placeholder="Asset Name"
                  value={assetForm.name}
                  onChange={(e) => setAssetForm({ ...assetForm, name: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-900"
                  required
                />
                <label>Asset Category</label>
                <select
                  value={assetForm.category}
                  onChange={(e) => setAssetForm({ ...assetForm, category: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-900"
                  required
                >
                  <option value="">Select Category</option>
                  {assetCategories.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.name}
                    </option>
                  ))}
                </select>
                <label>Asset Cost</label>
                <input
                  type="number"
                  placeholder="Cost (KSh)"
                  value={assetForm.cost}
                  onChange={(e) => setAssetForm({ ...assetForm, cost: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-900"
                  required
                />
                <label>Purchase Date</label>
                <input
                  type="date"
                  value={assetForm.purchase_date}
                  onChange={(e) => setAssetForm({ ...assetForm, purchase_date: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-900"
                  required
                />
                <label>Depreciation Method</label>
                <select
                  value={assetForm.depreciation_method}
                  onChange={(e) => setAssetForm({ ...assetForm, depreciation_method: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-900"
                >
                <option>None</option>
                  <option value="straight_line">Straight Line</option>
                  <option value="reducing_balance">Declining Balance</option>
                </select>
                <label>Useful Life</label>
                <input
                  type="number"
                  placeholder="Useful Life (years)"
                  value={assetForm.lifespan}
                  onChange={(e) => setAssetForm({ ...assetForm, lifespan: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-900"
                  required
                />
              </div>
              <div className="flex space-x-3 mt-6">
                <button
                  onClick={() => {
                    setShowAssetModal(false);
                    setEditingAsset(null);
                  }}
                  className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm"
                >
                  Cancel
                </button>
                <button
                  onClick={handleAddAsset}
                  className="flex-1 px-4 py-2 bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition-colors text-sm shadow-sm"
                >
                  {editingAsset ? 'Update Asset' : 'Add Asset'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Investment Modal */}
        {showInvestModal && (
          <div className="fixed inset-0 bg-blackk bg-opacity-30 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl p-6 w-full max-w-md shadow-lg">
              <h3 className="text-lg font-light text-gray-900 mb-4">New Investment</h3>
              <div className="space-y-4">
                <input
                  type="text"
                  placeholder="MMF Name"
                  value={investForm.mmf_name}
                  onChange={(e) => setInvestForm({ ...investForm, mmf_name: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-900"
                  required
                />
                <input
                  type="number"
                  placeholder="Amount (KSh)"
                  value={investForm.amount}
                  onChange={(e) => setInvestForm({ ...investForm, amount: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-900"
                  required
                />
                <select
                  value={investForm.account_id}
                  onChange={(e) => setInvestForm({ ...investForm, account_id: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-900"
                  required
                >
                  <option value="">Select Account</option>
                  {accounts.map((acc) => (
                    <option key={acc.id} value={acc.id}>
                      {acc.name} (KSh {Number(acc.balance)})
                    </option>
                  ))}
                </select>
                <input
                  type="date"
                  value={investForm.date}
                  onChange={(e) => setInvestForm({ ...investForm, date: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-900"
                  required
                />
              </div>
              <div className="flex space-x-3 mt-6">
                <button
                  onClick={() => setShowInvestModal(false)}
                  className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm"
                >
                  Cancel
                </button>
                <button
                  onClick={handleInvest}
                  className="flex-1 px-4 py-2 bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition-colors text-sm shadow-sm"
                >
                  Invest
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Profit Modal */}
        {showProfitModal && (
          <div className="fixed inset-0 bg-blackk bg-opacity-30 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl p-6 w-full max-w-md shadow-lg">
              <h3 className="text-lg font-light text-gray-900 mb-4">Record Profit/Interest</h3>
              <div className="space-y-4">
                <select
                  value={profitForm.investment_id}
                  onChange={(e) => setProfitForm({ ...profitForm, investment_id: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-900"
                  required
                >
                  <option value="">Select Investment</option>
                  {investments.map((inv) => (
                    <option key={inv.id} value={inv.id}>
                      {inv.mmf_name}
                    </option>
                  ))}
                </select>
                <input
                  type="number"
                  placeholder="Profit Amount (KSh)"
                  value={profitForm.amount}
                  onChange={(e) => setProfitForm({ ...profitForm, amount: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-900"
                  required
                />
                <select
                  value={profitForm.type}
                  onChange={(e) => setProfitForm({ ...profitForm, type: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-900"
                >
                  <option value="interest">Interest</option>
                  <option value="dividend">Dividend</option>
                  <option value="capital_gain">Capital Gain</option>
                   <option value="other">Other</option>
                </select>
                <input
                  type="date"
                  value={profitForm.date}
                  onChange={(e) => setProfitForm({ ...profitForm, date: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-900"
                  required
                />
              </div>
              <div className="flex space-x-3 mt-6">
                <button
                  onClick={() => setShowProfitModal(false)}
                  className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm"
                >
                  Cancel
                </button>
                <button
                  onClick={handleAddProfit}
                  className="flex-1 px-4 py-2 bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition-colors text-sm shadow-sm"
                >
                  Record Profit
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Assets;